import { Country } from 'library/ts/model/enums/geo/Country';
import { RuntimeVO } from 'library/ts/utilities/RuntimeVO';
import { DEFAULT_RELATIVE_VALUE, DefaultSmartTagReadyCallback } from 'tag/ts/smart_tag/default/DefaultSmartTagReadyCallback';
import { Constants } from 'tag/ts/smart_tag/model/Constants';
import { ParentEnvelope } from 'tag/ts/smart_tag/model/parent/envelope/ParentEnvelope';
import { ParentEnvelopeHostPattern } from 'tag/ts/smart_tag/model/parent/envelope/ParentEnvelopeHostPattern';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
export class SmartTagRuntimeVO extends RuntimeVO {
    constructor() {
        super('smart-tag-debug', 'tag');
    }
    get readyCallback() {
        const onReadyParam = this.utils.URL.getQueryField('onReady', this.app.url);
        const defaultRelativeValue = DEFAULT_RELATIVE_VALUE;
        let callbackObject = DefaultSmartTagReadyCallback;
        if (this.utils.Type.isString(onReadyParam)
            &&
                this.utils.String.trim(onReadyParam).length > 0
            &&
                this.utils.Type.isBase64(onReadyParam)) {
            callbackObject = this.utils.DeepMerge.deepmerge(callbackObject, this.utils.Convert.objectDecode(this.utils.String.trim(onReadyParam)));
        }
        switch (this.utils.Type.isObject(callbackObject.payload)) {
            case false:
                callbackObject.payload = { relative: defaultRelativeValue };
                break;
            case true:
                if (this.utils.Type.isBoolean(callbackObject.payload.relative) === false) {
                    callbackObject.payload.relative = defaultRelativeValue;
                }
                break;
        }
        if (this.utils.Type.isUndefined(callbackObject.namespace)) {
            callbackObject.namespace = window;
        }
        else {
            if (this.utils.Type.isString(callbackObject.namespace)) {
                callbackObject.namespace = this.utils.DOM.getDeepVal(window, callbackObject.namespace);
            }
        }
        if (this.utils.Type.isUndefined(callbackObject.method)) {
            callbackObject.method = Constants.getInstance().FUNCTION_SMART_TAG_ON_READY;
        }
        callbackObject.method = this.utils.String.trim(callbackObject.method);
        callbackObject.method = this.utils.DOM.getDeepVal(callbackObject.namespace, callbackObject.method);
        return callbackObject;
    }
    get parentEnvelope() {
        const topHost = this.top.parsed.host.toLowerCase().trim();
        const tests = [];
        Object.entries(ParentEnvelope).forEach(([key, value]) => {
            tests.push({
                pattern: ParentEnvelopeHostPattern[key],
                env: value
            });
        });
        let returnEnvelope = undefined;
        for (let i = 0; i < tests.length; i++) {
            const oneTest = tests[i];
            if (topHost.includes(oneTest.pattern)) {
                returnEnvelope = oneTest.env;
                break;
            }
        }
        const isInternationalDesktopProd = () => {
            let returnValue = undefined;
            if (this.utils.Type.isString(this?.readyCallback?.country) && !this.utils.Type.isEmpty(this?.readyCallback?.country)) {
                returnValue = this?.readyCallback?.country === Country.US;
            }
            if (!this.utils.Type.isBoolean(returnValue)) {
                if (this.utils.Type.isBoolean(window?.CBS?.Registry?.region?.international)) {
                    returnValue = window.CBS.Registry.region.international;
                }
            }
            if (!this.utils.Type.isBoolean(returnValue)) {
                if (this.utils.Type.isElement(document?.body)) {
                    returnValue = !this.utils.CSS.hasClass(document?.body, 'property-us');
                }
            }
            return returnValue;
        };
        switch (this?.readyCallback?.env) {
            case EmbedType.DESKTOP:
            case EmbedType.MOBILE_WEB:
                switch (returnEnvelope) {
                    case ParentEnvelope.PROD_PPLUS:
                    case ParentEnvelope.PROD_INT:
                        if (isInternationalDesktopProd() === true) {
                            returnEnvelope = ParentEnvelope.PROD_INT;
                        }
                        break;
                }
                break;
            case EmbedType.HTML5:
                break;
        }
        return returnEnvelope;
    }
}
